export default __webpack_public_path__ + "static/media/havingfun.754460cc.jpg";